import React, {FC, PropsWithChildren} from "react";
import "./ui.css";

// Page padding for top-level organizer pages. Event workspace pages are already padded by the workspace.
export const AdminPage: FC<PropsWithChildren<{className?: string}>> = ({className, children}) => (
    <div className={["ati-page", className].filter(Boolean).join(" ")}>{children}</div>
);
